import * as request from './utils/requester';

export const getAll = (page) => request.get(`/program?page=${page}`);

export const getById = (id) => request.get(`/program/${id}`);

export const create = (data) => request.post('/program', data);

export const edit = (data) => request.put(`/program/${data._id}`, data);

export const del = (data) => request.del(`/program/${data._id}`);


export const getOption = (option) => request.get(`/program?option=${option}`);